import{createContext as e}from"react";const a=e({selectedValue:void 0,handleValueChange:void 0});export{a as default};
